import React from 'react';

const Footer = () => {
    return (
        <>
<footer className="footer bg-dark bg-ash py-5" style={{ marginBottom: -100 }}>
                <div className="container">
                    <div className="row pt-5">
                        <div className="col-md-4">
                            {/* Column 1 Content */}
                            <h4 className='text-white'>Contact Us</h4>
                            <p className='text-white'>Address: 123 Main St, City, Country</p>
                            <p className='text-white'>Email: info@example.com</p>
                            <p className='text-white'>Phone: +123 456 7890</p>
                        </div>
                        <div className="col-md-4">
                            {/* Column 2 Content */}
                            <h4 className='text-white'>Website Information</h4>
                            <ul className="list-unstyled">
                                <li className='text-white'>About Us</li>
                                <li className='text-white'>Services</li>
                                <li className='text-white'>Contact</li>
                                <li className='text-white'>Payment</li>

                            </ul>
                        </div>
                        <div className="col-md-4">
                            {/* Column 3 Content */}
                            <h4 className='text-white'> Connect With Us</h4>
                            <ul className="list-unstyled">
                                <li className='text-white'><i className="fab fa-facebook"></i> Facebook</li>
                                <li className='text-white'><i className="fab fa-twitter"></i> Twitter</li>
                                <li className='text-white'><i className="fab fa-instagram"></i> Instagram</li>
                                <li className='text-white'><i className="fab fa-instagram"></i> Linkedin</li>

                                {/* Add more social icons as needed */}
                            </ul>
                        </div>
                    </div>
                    
                </div>
                <div className="container text-dark pt-5">
                    <p className='text-white '>&copy; 2024 Metronic. All Rights Reserved.</p>
                </div>
            </footer>
        </>
    );
}

export default Footer;
